(function () {

    "use strict";

    angular
        .module("harriApp")
        .service("hmapUiService", hmapUiService);

    hmapUiService.$inject = ['hUser', 'brandServices', '$q'];

    function hmapUiService(hUser, brandServices, $q) {
        var self = this;
        var CACHE_KEYS = {
            HMAP_ACTIVE_UI_VIEW: 'hmap_active_ui_view',
            HMAP_ACTIVE_VIEW: 'hmap_active_view',
            HMAP_ACTIVE_SORTING: 'hmap_active_sorting',
        };
        var isFirstLoad = true;
        var isExpandingBrands = {SAME_GP_LEVEL: false, NEW_GP_LEVEL: false};
        var accessType = hUser.getUserAccessType();

        self.HMAP_UI_VIEW = {
            LIST: {
                name: 'LIST',
                value: $filter('translate')('List'),
                automation: 'AccessPortalSelectListView',
            },
            CARDS: {
                name: 'CARDS',
                value: $filter('translate')('Cards'),
                automation: 'AccessPortalSelectCardView',
            },
        };
        self.HMAP_VIEW = {
            ALL: {
                name: 'ALL',
                value: $filter('translate')('All'),
            },
            SUBWAY_VIEW: {
                name: 'SUBWAY_VIEW',
                value: $filter('translate')('Ownership’s View'),
            },
            STARRED: {
                name: 'STARRED',
                value: $filter('translate')('Starred'),
            }
        };
        self.BRAND_SORTING = {
            ALPHABETICAL: {
                name: 'ALPHABETICAL',
                value: $filter('translate')('Alphabetical'),
            },
            GROUPED_BY_PARENT: {
                name: 'GROUPED_BY_PARENT',
                value: $filter('translate')('Grouped by parent'),
            }
        };

        var checkIpcIntegrationService = function () {
            var defer = $q.defer();
            brandServices.check(brandServices.SERVICES.IPC_INTEGRATION, hUser.getUserContext().brand_id)
                .then(function (isIPCServiceEnabled) {
                    self.isIPCServiceEnabled = isIPCServiceEnabled;
                    defer.resolve(isIPCServiceEnabled);
                })
                .catch(function (err) {
                    defer.reject(err);
                });

            return defer.promise;
        }

        self.prepareDashboardViews = function () {
            var defer = $q.defer();
            checkIpcIntegrationService().then(function (isIPCServiceEnabled) {
                var dashboardViews;
                if (isIPCServiceEnabled) {
                    if (hUser.getEntryMode().brand_type === 'GP-5' && accessType === 'EXPLICIT') {
                        dashboardViews = [self.HMAP_VIEW.ALL, self.HMAP_VIEW.SUBWAY_VIEW, self.HMAP_VIEW.STARRED];
                    } else {
                        dashboardViews = [self.HMAP_VIEW.SUBWAY_VIEW, self.HMAP_VIEW.STARRED];
                    }
                } else {
                    dashboardViews = [self.HMAP_VIEW.ALL, self.HMAP_VIEW.STARRED];
                }
                defer.resolve(dashboardViews);
            })
                .catch(function (err) {
                    defer.reject(err);
                });

            return defer.promise;
        }

        self.getActiveUiView = function () {
            var hmapUiViewCache = HStorageManager.get({
                key: CACHE_KEYS.HMAP_ACTIVE_UI_VIEW,
                storageLevel: HStorageManager.StorageLevels.LOCAL_STORAGE
            });

            if (hmapUiViewCache) {
                return hmapUiViewCache;
            }

            return self.HMAP_UI_VIEW.CARDS;
        };

        self.setActiveUiView = function (view) {
            HStorageManager.put({
                key: CACHE_KEYS.HMAP_ACTIVE_UI_VIEW,
                storageLevel: HStorageManager.StorageLevels.LOCAL_STORAGE,
                value: view
            });
        };

        self.setHmapActiveView = function (view) {
            HStorageManager.put({
                storageLevel: HStorageManager.StorageLevels.LOCAL_STORAGE,
                key: CACHE_KEYS.HMAP_ACTIVE_VIEW,
                value: view
            });
        };

        self.getHmapActiveView = function () {
            var hmapViewCache = HStorageManager.get({
                storageLevel: HStorageManager.StorageLevels.LOCAL_STORAGE,
                key: CACHE_KEYS.HMAP_ACTIVE_VIEW
            });
            var activeView;
            if (hmapViewCache) {
                return hmapViewCache;
            }
            if (self.isIPCServiceEnabled) {
                if (hUser.getEntryMode().brand_type === 'GP-5' && accessType === 'EXPLICIT') {
                    activeView = self.HMAP_VIEW.ALL;
                } else {
                    activeView = self.HMAP_VIEW.SUBWAY_VIEW;
                }
            } else {
                activeView = self.HMAP_VIEW.ALL;
            }
            return activeView;
        };

        self.getHmapActiveSorting = function () {
            var hmapSortingCache = HStorageManager.get({
                key: CACHE_KEYS.HMAP_ACTIVE_SORTING,
                storageLevel: HStorageManager.StorageLevels.LOCAL_STORAGE
            })

            if (hmapSortingCache) {
                return hmapSortingCache;
            }

            return self.BRAND_SORTING.ALPHABETICAL;
        };

        self.setHmapActiveSorting = function (sortingOption) {
            HStorageManager.put({
                storageLevel: HStorageManager.StorageLevels.LOCAL_STORAGE,
                key: CACHE_KEYS.HMAP_ACTIVE_SORTING,
                value: sortingOption
            });
        };

        self.setFirstLoad = function (value) {
            isFirstLoad = value;
        };

        self.getFirstLoad = function () {
            return isFirstLoad;
        };

        self.setExpandingBrands = function (key, value) {
            isExpandingBrands[key] = value;
        };

        self.getExpandingBrands = function () {
            return isExpandingBrands;
        };

        self.reset = function () {
            isFirstLoad = true;
            isExpandingBrands = false;
        };
    }
})();